module.exports = __webpack_public_path__ + "img/5.45e755cf.jpg";